<div class="p-[40px]" *transloco="let t">
    <div class="text-primary text-title font-semibold">Completa tutti i passaggi per accedere al tuo gestionale</div>
   <div class="flex place-content-center mt-8" *ngIf="updateStepper"> <std-stepper
      [statusClass]="
         {success: 'bg-primary',
         working: 'bg-[#9A5A8F]',incomplete: 'bg-[#E3E3E3]'}
         "
      direction="horizontal" diameterBall="60px" linkClass="!h-[4px] !w-[100px]" [data]="dataStepper"></std-stepper></div>
   <div (click)="showModal()" class="size-[48px] ml-auto"><svg  class="size-[48px] mt-4 cursor-pointer" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.91214 2.40112C4.73614 2.40112 2.16089 4.97637 2.16089 8.15237C2.16089 11.3284 4.73614 13.9036 7.91214 13.9036C11.0881 13.9036 13.6634 11.3284 13.6634 8.15237C13.6634 4.97637 11.0881 2.40112 7.91214 2.40112Z" stroke="black" stroke-width="1.00189" stroke-miterlimit="10"/>
<path d="M7.03638 7.27771H8.037V10.905" stroke="black" stroke-width="1.00189" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.66064 11.0282H9.41327" stroke="black" stroke-width="1.00189" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M7.91461 4.46442C7.75342 4.46442 7.59585 4.51222 7.46182 4.60177C7.3278 4.69132 7.22333 4.81861 7.16165 4.96753C7.09996 5.11645 7.08382 5.28032 7.11527 5.43842C7.14672 5.59652 7.22434 5.74174 7.33832 5.85572C7.4523 5.9697 7.59752 6.04732 7.75561 6.07876C7.91371 6.11021 8.07758 6.09407 8.2265 6.03239C8.37542 5.9707 8.50271 5.86624 8.59227 5.73221C8.68182 5.59819 8.72962 5.44061 8.72962 5.27942C8.72962 5.06327 8.64375 4.85597 8.49091 4.70313C8.33807 4.55028 8.13077 4.46442 7.91461 4.46442Z" fill="black"/>
</svg></div> 
<std-modal [closeOnOutside]="false" headerClass="bg-primary text-tertiary text-title" [show]="showModalInfo"
   (close)="showModalInfo = false">
   <div header>{{t('stepDescription')}}</div>
   <div content class="text-large max-w-[90vw]">
      <div class="max-w-[500px]"> @if(dataStepper[1].status == 'working'){
         <div class="grid gap-y-5">
            <div class="font-semibold text-large">{{t('info1')}}</div>
             <div><span class="text-primary font-bold">{{t('labels.companyName')}}:</span>{{t('companyNameDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('vat')}}:</span>{{t('vatDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('cell')}}:</span>{{t('cellDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('address')}}:</span>{{t('addressDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('city')}}:</span>{{t('cityDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('cap')}}:</span>{{t('capDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('state')}}:</span>{{t('stateDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('country')}}:</span>{{t('countryDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('tax')}}:</span>{{t('taxDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('email')}}:</span>{{t('emailDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('pec')}}:</span>{{t('pecDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('sdi')}}:</span>{{t('sdiDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('recoveryCode')}}:</span>{{t('recoveryCodeDesc')}}</div>
         </div>
         }
         @if(dataStepper[2].status == 'working'){
         <div class="grid gap-y-5">
            <div class="font-semibold text-large">{{t('info2')}}</div>
           <div><span class="text-primary font-bold">{{t('salonImage')}}:</span>{{t('salonImageDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('email')}}:</span>{{t('emailDescSalon')}}</div>
           <div><span class="text-primary font-bold">{{t('name')}}:</span>{{t('nameDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('desc')}}:</span>{{t('descDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('address')}}:</span>{{t('addressSalonDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('city')}}:</span>{{t('citySalonDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('cell')}}:</span>{{t('cellSalonDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('cap')}}:</span>{{t('capSalonDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('state')}}:</span>{{t('stateSalonDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('country')}}:</span>{{t('countrySalonDesc')}}</div>

         </div>
         }
         @if(dataStepper[3].status == 'working'){
         <div class="grid gap-y-5">
            <div class="font-semibold text-large">{{t('info3')}}</div>
            <div><span class="text-primary font-bold">{{t('operatorImage')}}:</span>{{t('operatorImageDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('labels.firstName')}}:</span>{{t('nameOperatorDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('labels.lastName')}}:</span>{{t('surnameOperatorDesc')}}</div>
         </div>
         }
         @if(dataStepper[4].status == 'working'){
         <div class="grid gap-y-5">
            <div class="font-semibold text-large">{{t('info4')}}</div>
            <div><span class="text-primary font-bold">{{t('serviceImage')}}:</span>{{t('serviceImageDesc')}}</div>
            <div><span class="text-primary font-bold">{{t('price')}}:</span>{{t('priceDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('typeP')}}:</span>{{t('typeProductDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('service')}}:</span>{{t('serviceDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('duration')}}:</span>{{t('durationDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('labels.daysReminder')}}:</span>{{t('daysReminderDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('name')}}:</span>{{t('nameServiceDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('desc')}}:</span>{{t('descSalonDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('category')}}:</span>{{t('categoryServiceDesc')}}</div>
         </div>
         }
         @if(dataStepper[5].status == 'working'){
         <div class="grid gap-y-5">
            <div class="font-semibold text-large">{{t('info5')}}</div>
            <div><span class="text-primary font-bold">{{t('day')}}:</span>{{t('dayDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('openHours')}}:</span>{{t('openHoursDesc')}}</div>
           <div><span class="text-primary font-bold">{{t('closeHours')}}:</span>{{t('openHoursDesc')}}</div>
         </div>
         }
      </div>
   </div>
</std-modal>

    @if(!isCompanyComplete){
      <div class="mt-4">
         <div class="text-primary text-large font-semibold">{{t('completeAll')}}</div>
         <div class="md:flex flex-wrap mt-4 gap-[5%]">
      
            <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'"
               [(ngModel)]="company.companyName" [label]="t('labels.companyName') + '*'" labelPosition="top"
               [placeholder]="t('placeholders.companyName') + '*'"></std-input>
      
            <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'" [(ngModel)]="company.vat"
               [label]="t('labels.vat') + '*'" labelPosition="top" [placeholder]="t('placeholders.vat') + '*'"></std-input>
      
            <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'"
               [(ngModel)]="company.phoneNumber" [label]="t('labels.phoneNumber') + '*'" labelPosition="top"
               [placeholder]="t('placeholders.phoneNumber') + '*'"></std-input>
         </div>
         <div class="md:flex flex-wrap mt-4 gap-[5%]">
            <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'" [(ngModel)]="company.address"
               [label]="t('labels.address') + '*'" labelPosition="top"
               [placeholder]="t('placeholders.address') + '*'"></std-input>
      
            <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'" [(ngModel)]="company.city"
               [label]="t('labels.city') + '*'" labelPosition="top" [placeholder]="t('placeholders.city') + '*'"></std-input>
      
            <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'" [(ngModel)]="company.zipcode"
               [label]="t('labels.zipcode') + '*'" labelPosition="top"
               [placeholder]="t('placeholders.zipcode') + '*'"></std-input>
         </div>
         <div class="md:flex flex-wrap mt-4 gap-[5%]"> <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input"
               [type]="'text'" [(ngModel)]="company.state" [label]="t('labels.state') + '*'" labelPosition="top"
               [placeholder]="t('placeholders.state') + '*'"></std-input>
            <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'" [(ngModel)]="company.country"
               [label]="t('labels.country') + '*'" labelPosition="top"
               [placeholder]="t('placeholders.country') + '*'"></std-input>
            <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'" [(ngModel)]="company.tax"
               [label]="t('labels.tax') " labelPosition="top" [placeholder]="t('placeholders.tax') "></std-input>
         </div>
         <div class="md:flex flex-wrap mt-4 gap-[5%]"> <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input"
               [type]="'text'" [(ngModel)]="company.email" [label]="t('labels.email') + '*'" labelPosition="top"
               [placeholder]="t('placeholders.email') + '*'"></std-input>
            <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'" [(ngModel)]="company.pec"
               [label]="t('labels.pec') " labelPosition="top" [placeholder]="t('placeholders.pec') "></std-input>
            <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'" [(ngModel)]="company.sdi"
               [label]="t('labels.sdi')" labelPosition="top" [placeholder]="t('placeholders.sdi')"></std-input>
               <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'number'" [(ngModel)]="company.recovery_code"
               [label]="t('recoveryCode') + '*'" labelPosition="top" [placeholder]="t('recoveryCode')+ '*'"></std-input>
         </div>
      </div>
      
      <div class="w-[250px] mx-auto mt-8" [ngClass]="{'pointer-events-none opacity-35': !(company.address &&
         company.city &&
         company.companyName &&
         company.country &&
         company.email &&
         company.phoneNumber &&
         company.state &&
         company.zipcode && company.recovery_code)}">
         <std-button (click)="saveCompany(t)" buttonClass="bg-primary hover:bg-primary focus:bg-primary text-secondary">{{t('continue')}}</std-button>
      </div>
      
      
      }

@if(isCompanyComplete && !(user.noOfSalons > 0)){
<div class="mt-4"> 
   <div class="text-primary text-large font-semibold">{{t('completeAll')}}</div>
   <input id="select-salon-image" class="hidden" type="file" (change)="salonImage($event)"
      accept="image/*">
   @if(!salonImageUrl){
   <div (click)="clickSalonImage()"
      class="border-[2px] select-none cursor-pointer my-4 border-primary rounded-md flex items-center place-content-center min-h-[200px] min-w-[700px] max-w-[300px] max-h-[350px] overflow-hidden mx-auto">

      <div class="text-center text-title text-primary font-bold">{{t('salonImage')}}</div>





   </div>}

   @if(salonImageUrl){
   <img [src]="salonImageUrl" (click)="clickSalonImage()"
      class="mx-auto max-w-[80%] max-h-[350px] border-[2px] select-none cursor-pointer my-4 border-primary rounded-md">
   }

   <div class="md:flex flex-wrap mt-4 gap-[5%]">

      <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'"
         [(ngModel)]="salon.email" [label]="t('labels.email') + '*'" labelPosition="top"
         [placeholder]="t('placeholders.email') + '*'"></std-input>




      <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'"
         [(ngModel)]="salon.name" [label]="t('labels.name') + '*'" labelPosition="top"
         [placeholder]="t('placeholders.name') + '*'"></std-input>

      <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'"
         [(ngModel)]="salon.description" [label]="t('labels.description') + '*'" labelPosition="top"
         [placeholder]="t('placeholders.description') + '*'"></std-input>
   </div>
   <div class="md:flex flex-wrap mt-4 gap-[5%]">
      <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'"
         [(ngModel)]="salon.address" [label]="t('labels.address') + '*'" labelPosition="top"
         [placeholder]="t('placeholders.address') + '*'"></std-input>

      <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'"
         [(ngModel)]="salon.city" [label]="t('labels.city') + '*'" labelPosition="top"
         [placeholder]="t('placeholders.city') + '*'"></std-input>

      <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'"
         [(ngModel)]="salon.phoneNumber" [label]="t('labels.phoneNumber') + '*'" labelPosition="top"
         [placeholder]="t('placeholders.phoneNumber') + '*'"></std-input>
   </div>
   <div class="md:flex flex-wrap mt-4 gap-[5%]"> <std-input class="w-[30%]" customInputClass="custom-input"
         customLabel="label-input" [type]="'text'" [(ngModel)]="salon.zipcode" [label]="t('labels.zipcode') + '*'"
         labelPosition="top" [placeholder]="t('placeholders.zipcode') + '*'"></std-input>
      <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'"
         [(ngModel)]="salon.state" [label]="t('labels.state') + '*'" labelPosition="top"
         [placeholder]="t('placeholders.state') + '*'"></std-input>
      <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'"
         [(ngModel)]="salon.country" [label]="t('labels.country') + '*' " labelPosition="top"
         [placeholder]="t('placeholders.country') + '*' "></std-input>
   </div>
</div>

<div class="w-[250px] mx-auto mt-8" [ngClass]="{'pointer-events-none opacity-35': !(salon.address &&
      salon.name &&
      salon.description &&
      salon.address &&
      salon.city &&
      salon.phoneNumber &&
      salon.zipcode &&
      salon.state &&
      salon.country&&
      salon.email&& salonImageUrl)}">
   <std-button (click)="saveSalon(t)"
      buttonClass="bg-primary hover:bg-primary focus:bg-primary text-secondary">{{t('continue')}}</std-button>
</div>


}

@if(isCompanyComplete && user.noOfSalons > 0 && !(user.noOfOperators > 0)){
   <div class="mt-4">
      <div class="text-primary text-large font-semibold">{{t('completeAll')}}</div>


      <input id="select-operator-image" class="hidden" type="file" (change)="operatorImage($event)"
      accept="image/*">
   @if(!operatorImageUrl){
   <div (click)="clickOperatorImage()"
      class="border-[2px] select-none cursor-pointer my-4 border-primary rounded-md flex items-center place-content-center min-h-[200px] min-w-[700px] max-w-[300px] max-h-[350px] overflow-hidden mx-auto">

      <div class="text-center text-title text-primary font-bold">{{t('operatorImage')}}</div>





   </div>}

   @if(operatorImageUrl){
   <img [src]="operatorImageUrl" (click)="clickOperatorImage()"
      class="mx-auto max-w-[80%] max-h-[350px] border-[2px] select-none cursor-pointer my-4 border-primary rounded-md">
   }


      <div class="md:flex flex-wrap mt-4 gap-[5%]">
   
         <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'"
            [(ngModel)]="operator.firstName" [label]="t('labels.firstName') + '*'" labelPosition="top"
            [placeholder]="t('placeholders.firstName') + '*'"></std-input>
   
         <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'" [(ngModel)]="operator.lastName"
            [label]="t('labels.lastName') + '*'" labelPosition="top" [placeholder]="t('placeholders.lastName') + '*'"></std-input>

      </div>
   </div>
   
   <div class="w-[250px] mx-auto mt-8" [ngClass]="{'pointer-events-none opacity-35': !(operator.firstName && operator.lastName && operatorImageUrl )}">
      <std-button (click)="saveOperator(t)" buttonClass="bg-primary hover:bg-primary focus:bg-primary text-secondary">{{t('continue')}}</std-button>
   </div>
   
   
   }

   @if(isCompanyComplete && user.noOfSalons > 0 && user.noOfOperators > 0 && !(user.noOfProducts > 0) && showProducts){
      <div class="mt-4">
         <div class="text-primary text-large font-semibold">{{t('completeAll')}}</div>
   
   
         <input id="select-product-image" class="hidden" type="file" (change)="productImage($event)"
         accept="image/*">
      @if(!productImageUrl){
      <div (click)="clickProductImage()"
         class="border-[2px] select-none cursor-pointer my-4 border-primary rounded-md flex items-center place-content-center min-h-[200px] min-w-[700px] max-w-[300px] max-h-[350px] overflow-hidden mx-auto">
   
         <div class="text-center text-title text-primary font-bold">{{t('productImage')}}</div>
   
   
   
   
   
      </div>}
   
      @if(productImageUrl){
      <img [src]="productImageUrl" (click)="clickProductImage()"
         class="mx-auto max-w-[80%] max-h-[350px] border-[2px] select-none cursor-pointer my-4 border-primary rounded-md">
      }
   
  <div (click)="suggestionProduct()" class="w-[400px] ml-auto"><std-button buttonClass="bg-primary ml-auto focus:bg-primary hover:bg-primary text-[16px] text-tertiary">{{t('useSuggestedProduct')}}</std-button></div> 

         <div class="md:flex flex-wrap mt-4 gap-[5%]">
      
               <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'number'"
               [(ngModel)]="product.price" [label]="t('labels.price') + '*'" labelPosition="top"
               [placeholder]="t('placeholders.price') + '*'"></std-input>

               <std-select class="w-[30%]" [currentValue]="" customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" (onChangeValue)="manageSelectProduct($event,'type')" [currentValue]="{id:1,label:t('product')}" [data]="[{id:1,label:t('product')}]" bindLabel="label"
               bindValue="id" customClassContaier="border-primary custom-select"
               [label]="t('productType')+ '*'" labelPosition="top"
               [placeholder]="t('productType')+ '*'"></std-select>

               <std-select class="w-[30%]"  [currentValue]="productSelect.category" customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" (onChangeValue)="manageSelectProduct($event,'serviceId')" [data]="subcategoriesList" bindLabel="name"
               bindValue="id" customClassContaier="border-primary custom-select"
               [label]="t('service')+ '*'" labelPosition="top"
               [placeholder]="t('service')+ '*'"></std-select>
      
         </div>

         <div class="md:flex flex-wrap mt-4 gap-[5%]">
            <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'number'"
            [(ngModel)]="product.duration" [label]="t('labels.durationMinute') + '*'" labelPosition="top"
            [placeholder]="t('placeholders.durationMinute') + '*'"></std-input>
            
            <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'number'"
            [(ngModel)]="product.days" [label]="t('labels.daysReminder') + '*'" labelPosition="top"
            [placeholder]="t('placeholders.daysReminder') + '*'"></std-input>

               <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'"
               [(ngModel)]="product.name" [label]="t('labels.name') + '*'" labelPosition="top"
               [placeholder]="t('placeholders.name')+ '*'"></std-input>
   
         </div>

         <div class="md:flex flex-wrap mt-4 gap-[5%]">
            <std-input class="w-[30%]" customInputClass="custom-input" customLabel="label-input" [type]="'text'"
            [(ngModel)]="product.description" [label]="t('labels.description') + '*'" labelPosition="top"
            [placeholder]="t('placeholders.description') + '*'"></std-input>
            
            <std-select  class="w-[30%]" [currentValue]="productSelect.category" direction="up" customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" (onChangeValue)="manageSelectProduct($event,'categoryId')" [data]="categoriesList" bindLabel="name"
            bindValue="id" customClassContaier="border-primary custom-select"
            [label]="t('categoryId')+ '*'" labelPosition="top"
            [placeholder]="t('categoryId')+ '*'"></std-select>
         </div>

      </div>
      <div class="flex place-content-center mt-8 gap-4 flex-wrap">
     @if(canSkipProduct){ <div class="w-[250px]">
         <std-button (click)="showModalSkipProduct = true" buttonClass="bg-primary hover:bg-primary focus:bg-primary text-secondary">{{t('skipStep')}}</std-button>
      </div>}
       <div class="w-[250px]" [ngClass]="{'pointer-events-none opacity-35': !(productImageUrl && product.price && product.type && product.serviceId && product.duration && product.days && product.name && product.description && product.categoryId )}">
         <std-button (click)="saveProduct(t)" buttonClass="bg-primary hover:bg-primary focus:bg-primary text-secondary">{{t('add')}}</std-button>
      </div>
      @if(!canSkipProduct){ <div class="w-[250px]">
         <std-button (click)="continueProduct(t)" buttonClass="bg-primary hover:bg-primary focus:bg-primary text-secondary">{{t('continue')}}</std-button>
      </div>}
      </div>
      <std-modal [closeOnOutside]="false" headerClass="bg-primary text-tertiary text-title" [show]="showModalSkipProduct"
   (close)="showModalSkipProduct = false">
   <div header>{{t('skipStep')}}</div>
   <div content class="text-large max-w-[400px]">
      <div class="font-semibold text-large">{{t('warningSkipProduct')}}</div>
      <div class="flex gap-[10%] w-[400px] place-content-center mt-4">
         <div class="w-[45%]">
            <std-button (click)="showModalSkipProduct = false"
            buttonClass="bg-primary hover:bg-primary focus:bg-primary text-secondary">{{t('modal.cancel')}}</std-button>
         </div>
         <div class="w-[45%]">
            <std-button (click)="continueProduct(t)"
            buttonClass="bg-primary hover:bg-primary focus:bg-primary text-secondary">{{t('modal.confirm')}}</std-button>
         </div>
      </div>
   </div>
</std-modal>

      @if(listOfAddedProducts.length > 0 && showProducts){
      <div class="mt-4 text-title text-primary text-center">{{t('listOfAddedProducts')}}</div>
      <div class="mt-4">
         <std-table class="hide-bar-all bg-secondary fix-table" [data]="listOfAddedProducts"
            tableContainerClass="bg-secondary " headerClass=" bg-primary focus:bg-primary hover:bg-primary">
            <span stdoutTableColumn width="110"  [label]="
                  t('productImage')
                ">
                <ng-template #dataTableCell let-item="item">
                  <img [src]="item.imageToSee" class="max-w-[100px] max-h-[100px]">
                </ng-template>
            </span>
            <span stdoutTableColumn width="110" property="name" [label]="
                  t('name')
                ">
            </span>
            <span stdoutTableColumn width="110" property="price" [label]="
                  t('price')
                ">
            </span>
            <span stdoutTableColumn width="110" property="duration" [label]="
                  t('duration')
                ">
            </span>
            <span stdoutTableColumn width="110" property="days" [label]="
                  t('table.daysReminder')
                ">
            </span>
            <span stdoutTableColumn width="110" property="description" [label]="
                  t('description')
                ">
            </span>
         </std-table>
      </div>
      }
      
      }


      @if(isCompanyComplete && showTime && user.noOfSalons > 0 && user.noOfOperators > 0 && user.noOfProducts > 0 &&
      !(user.noOfTimetables)){
      
      <std-modal [closeOnOutside]="false" headerClass="bg-primary text-tertiary text-title" [show]="showModalSkipTime"
   (close)="showModalSkipTime = false">
   <div header>{{t('skipStep')}}</div>
   <div content class="text-large max-w-[400px]">
      <div class="font-semibold text-large">{{t('warningSkipTime')}}</div>
      <div class="flex gap-[10%] w-[400px] place-content-center mt-4">
         <div class="w-[45%]">
            <std-button (click)="showModalSkipTime = false"
            buttonClass="bg-primary hover:bg-primary focus:bg-primary text-secondary">{{t('modal.cancel')}}</std-button>
         </div>
         <div class="w-[45%]">
            <std-button (click)="continueTime(t)"
            buttonClass="bg-primary hover:bg-primary focus:bg-primary text-secondary">{{t('modal.confirm')}}</std-button>
         </div>
      </div>
   </div>
</std-modal>
      
      <div class="mt-4">
         <div class="text-primary text-large font-semibold">{{t('detailCompleteProfileTime')}}</div>
      
         <div class="md:flex flex-wrap mt-4 gap-[5%] place-content-center mb-4">
      
            <std-select class="w-[30%]" [data]="[
                  {
                    label: t('daysOfTheWeek.1'),
                    value: 1,
                  },
                  {
                    label: t('daysOfTheWeek.2'),
                    value: 2,
                  },
                  {
                    label:t('daysOfTheWeek.3'),
                    value: 3,
                  },
                  {
                    label: t('daysOfTheWeek.4'),
                    value: 4,
                  },
                  {
                    label: t('daysOfTheWeek.5'),
                    value: 5,
                  },
                  {
                    label: t('daysOfTheWeek.6'),
                    value: 6,
                  },
                  {
                    label: t('daysOfTheWeek.0'),
                    value: 0,
                  },
                ]" customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
               (onChangeValue)="manageSelectTimeTable($event,'day')" bindLabel="label" bindValue="value"
               customClassContaier="border-primary custom-select" [label]="t('day')+ '*'" labelPosition="top"
               [placeholder]="t('day')+ '*'"></std-select>
           
         </div>
      
         <div class="flex place-content-center gap-4">
            <div>
               <div class="text-primary text-center my-4 text-title font-bold ">{{t('openHours')}}</div>
               <std-time-picker [step5Minutes]="true" [showClock]="false" [use24h]="true" (changeDate)="timeTable.timeStart = $event.formattedTime"></std-time-picker>
            </div>
            <div>
               <div class="text-primary text-center my-4 text-title font-bold ">{{t('closeHours')}}</div>
               <std-time-picker [step5Minutes]="true" [showClock]="false" [use24h]="true" (changeDate)="timeTable.timeEnd = $event.formattedTime"></std-time-picker>
            </div>
         </div>
      
      </div>
      
 <div class="flex place-content-center mt-8 gap-4 flex-wrap">
     @if(canSkipTime){ <div class="w-[250px]">
         <std-button (click)="showModalSkipTime = true" buttonClass="bg-primary hover:bg-primary focus:bg-primary text-secondary">{{t('skipStep')}}</std-button>
      </div>}
       <div class="w-[250px]" [ngClass]="{'pointer-events-none opacity-35': !timeTable.day}">
         <std-button (click)="saveTimteTable(t)" buttonClass="bg-primary hover:bg-primary focus:bg-primary text-secondary">{{t('add')}}</std-button>
      </div>
      @if(!canSkipTime){  <div class="w-[250px]"
    >
         <std-button (click)="continueTime(t)"
            buttonClass="bg-primary hover:bg-primary focus:bg-primary text-secondary">{{t('continue')}}</std-button>
      </div>}
      </div>

     
@if(listOfAddedTimes.length > 0 && showProducts){
      <div class="mt-4 text-title text-primary text-center">{{t('listOfAddedTimes')}}</div>
      <div class="mt-4">
         <std-table class="hide-bar-all bg-secondary fix-table" [data]="listOfAddedTimes"
            tableContainerClass="bg-secondary " headerClass=" bg-primary focus:bg-primary hover:bg-primary">
            <span stdoutTableColumn width="110"  [label]="
                  t('day')
                ">
                <ng-template #dataTableCell let-item="item">
                  <span>{{t('daysOfTheWeek.' + item.day)}}</span>
                </ng-template>
            </span>
            
            <span stdoutTableColumn width="110" property="timeStart" [label]="
                  t('openHours')
                ">
            </span>
            <span stdoutTableColumn width="110" property="timeEnd" [label]="
                  t('closeHours')
                ">
            </span>
         </std-table>
      </div>
      }

      
      }

    <!-- <div class="text-primary text-medium font-semibold">compila questi passaggi:</div> -->
</div>